import { Check, ChevronRight, X } from "lucide-react";
import type { FinancingResult } from "../../shared/contracts";
import { currencyDetailed, systemLabel } from "../lib/format";

interface ComparisonTableProps {
  results: FinancingResult[];
  selectedKey: string;
  onSelect: (key: string) => void;
}

export function ComparisonTable({ results, selectedKey, onSelect }: ComparisonTableProps) {
  return (
    <section className="comparison" id="comparativo" aria-labelledby="comparison-title">
      <div className="comparison__heading">
        <div>
          <span className="section-kicker">04 · Comparativo aberto</span>
          <h2 id="comparison-title">Todos os custos, sem caixa-preta</h2>
        </div>
        <p>Selecione uma linha para abrir o cronograma correspondente.</p>
      </div>

      <div className="table-scroll">
        <table>
          <thead>
            <tr>
              <th>Instituição / sistema</th>
              <th>Taxa efetiva</th>
              <th>1ª parcela</th>
              <th>Última parcela</th>
              <th>Juros totais</th>
              <th>CET estimado</th>
              <th>Critério</th>
              <th>
                <span className="sr-only">Abrir</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {results.map((result, index) => (
              <tr
                key={result.key}
                className={selectedKey === result.key ? "is-selected" : ""}
                onClick={() => onSelect(result.key)}
              >
                <td>
                  <span
                    className="bank-swatch"
                    style={{ backgroundColor: result.accent }}
                    aria-hidden="true"
                  />
                  <span className="bank-cell">
                    <strong>
                      {index === 0 && result.eligibility.eligible ? (
                        <em>Menor total simulado</em>
                      ) : null}
                      {result.bankShortName}
                    </strong>
                    <small>{systemLabel(result.system)}</small>
                  </span>
                </td>
                <td>{result.annualRate.toFixed(2).replace(".", ",")}% a.a.</td>
                <td>
                  <strong>{currencyDetailed(result.firstPayment)}</strong>
                </td>
                <td>{currencyDetailed(result.lastPayment)}</td>
                <td>{currencyDetailed(result.totalInterest)}</td>
                <td>
                  {result.estimatedCetAnnual === null
                    ? "—"
                    : `${result.estimatedCetAnnual.toFixed(2).replace(".", ",")}% a.a.`}
                </td>
                <td>
                  <span
                    className={`eligibility ${
                      result.eligibility.eligible ? "eligibility--yes" : "eligibility--no"
                    }`}
                    title={result.eligibility.reasons.join(" ")}
                  >
                    {result.eligibility.eligible ? (
                      <>
                        <Check size={14} aria-hidden="true" /> Dentro das premissas
                      </>
                    ) : (
                      <>
                        <X size={14} aria-hidden="true" /> Revisar
                      </>
                    )}
                  </span>
                </td>
                <td>
                  <button
                    className="row-action"
                    type="button"
                    aria-label={`Abrir ${result.bankShortName} ${systemLabel(result.system)}`}
                    onClick={(event) => {
                      event.stopPropagation();
                      onSelect(result.key);
                      document.querySelector("#cronograma")?.scrollIntoView({ behavior: "smooth" });
                    }}
                  >
                    <ChevronRight size={18} aria-hidden="true" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
